import React, { useState, useEffect } from 'react';
import { Button, Card, CardBody, CardText, CardFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import { isGoogleCalendarConnected, disconnectGoogleCalendar } from '../../axios/oauth/oauth';
import { useAuthStore } from '../../zustand-store/auth.store';
const GoogleCalendarOAuthCard = ({ title, description, icon }) => {
  const [isGoogleCalendarIntegrated, setIsGoogleCalendarntegarted] = useState(false);
  const [loader, setLoader] = useState(true);
  const locationId = useAuthStore((state) => state.locationId);
  const businessId = useAuthStore((state) => state.businessId);
  const id = useAuthStore((state) => state.id);
  useEffect(() => {
    console.log(id);
    // Call the check function initially
    checkGoogleCalendarConnected();

    // Define the visibility handler
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        if (isGoogleCalendarIntegrated === false) {
          checkGoogleCalendarConnected();
        }
      } else {
        console.log('Tab is hidden');
      }
    };

    // Attach the event listener
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup function to remove the listener
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [locationId]);

  const checkGoogleCalendarConnected = async () => {
    let response = await isGoogleCalendarConnected(locationId, businessId);
    if (response.status === 200) {
      setIsGoogleCalendarntegarted(response?.data?.data);
      setLoader(false);
    }
  };

  const disconnect = async () => {
    setLoader(true);
    let response = await disconnectGoogleCalendar(locationId, businessId);
    if (response.status === 200) {
      setIsGoogleCalendarntegarted(false);
      setLoader(false);
    }
  };
  // const handleCalendarAuth = () => {
  //   // const width = 600;
  //   // const height = 600;
  //   // const left = window.innerWidth / 2 - width / 2;
  //   // const top = window.innerHeight / 2 - height / 2;

  //   const authWindow = window.open(
  //     `${import.meta.env.VITE_BASE_URL_BACKEND}/google/oauth?locationId=${locationId}&businessId=${businessId}&userId=${id}`,
  //     'Google OAuth'
  //     // `width=${width},height=${height},top=${top},left=${left}`
  //   );

  //   if (!authWindow) {
  //     alert('Popup blocked. Please allow popups for this site.');
  //     return;
  //   }
  // };

  return (
    <Card
      style={{ border: '1px solid', color: '#EFF2F7', cursor: 'pointer' }}
      onClick={() => {
        if (!isGoogleCalendarIntegrated) {
          //handleCalendarAuth();
          // alert("Work in progress")
        }
      }}
      id="square-integration-card">
      <CardBody>
        <div className="d-flex justify-content-between">
          <img style={{ width: '30px', height: '30px' }} src={icon} alt="" />
          {loader ? (
            <span className="text-warning">Loading...</span>
          ) : (
            <>
              {isGoogleCalendarIntegrated ? (
                <Button className="btn btn-success">
                  <i className="mdi mdi-check" /> Connected
                </Button>
              ) : (
                <span className="text-primary">
                  {/* Please connect */}
                  {'Comming Soon'}
                </span>
              )}
            </>
          )}
        </div>
        <p style={{ fontSize: '20px', color: '#495057' }} className="mt-2">
          {title}
        </p>
        <CardText style={{ color: '#74788D' }}>{description}</CardText>
      </CardBody>
      <CardFooter
        style={{ minHeight: '48px' }} // set enough height for your content
        className="d-flex align-items-center justify-content-end py-2">
        {isGoogleCalendarIntegrated ? (
          loader ? (
            <span className="text-warning mb-0">Loading...</span>
          ) : (
            <span
              className="text-danger mb-0 cursor-pointer"
              onClick={() => {
                if (window.confirm('Are you sure disconnect?')) {
                  disconnect(locationId);
                }
              }}>
              Disconnect
            </span>
          )
        ) : (
          // optional invisible placeholder to maintain structure
          <span className="invisible">Disconnect</span>
        )}
      </CardFooter>
    </Card>
  );
};

GoogleCalendarOAuthCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  isIntegrated: PropTypes.string,
  icon: PropTypes.any, // replace 'any' with the actual prop type
  onClick: PropTypes.any,
  integartionFlag: PropTypes.any
};

export default GoogleCalendarOAuthCard;
